import * as React from 'react'

export const TimeIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={17} viewBox="0 0 24 24" width={18} fill="#8c9095" {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z" />
  </svg>
)
